/**
 * @deprecated This file is deprecated. Use ErrorBoundary from '../ui/ErrorBoundary' instead.
 * This file is kept for backward compatibility only.
 */

import React from 'react';
import { ErrorBoundary } from '../ui/ErrorBoundary';
import { useLocation } from 'react-router-dom';

interface LocationAwareErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
}

// Legacy compatibility wrapper
export const LocationAwareErrorBoundary: React.FC<LocationAwareErrorBoundaryProps> = ({ 
  children, 
  fallback, 
  onError
}) => {
  const location = useLocation();
  
  // Use location as reset key so errors reset on navigation
  return (
    <ErrorBoundary
      fallback={fallback}
      onError={onError}
      resetKeys={[location.pathname]}
      level="page"
    >
      {children}
    </ErrorBoundary>
  );
};

export default LocationAwareErrorBoundary;